import React, { createContext, useContext, useLayoutEffect, useMemo, useState } from 'react';

type AppNavbarVisibility = {
  hidden: boolean;
  setHidden: (hidden: boolean) => void;
};

const AppNavbarVisibilityContext = createContext<AppNavbarVisibility>({
  hidden: false,
  setHidden: () => {},
});

export function AppNavbarVisibilityProvider({ children }: { children: React.ReactNode }) {
  const [hidden, setHidden] = useState(false);
  const value = useMemo(() => ({ hidden, setHidden }), [hidden]);
  return (
    <AppNavbarVisibilityContext.Provider value={value}>
      {children}
    </AppNavbarVisibilityContext.Provider>
  );
}

export function useAppNavbarHidden(): boolean {
  return useContext(AppNavbarVisibilityContext).hidden;
}

/**
 * For pages that render their own header. `Navbar` otherwise hides itself by
 * pathname, which the catch-all 404 route can't be listed in.
 * Layout effect so the swap lands before paint rather than flashing the navbar.
 */
export function useHideAppNavbar(): void {
  const { setHidden } = useContext(AppNavbarVisibilityContext);
  useLayoutEffect(() => {
    setHidden(true);
    return () => setHidden(false);
  }, [setHidden]);
}
